export default __webpack_public_path__ + "static/media/chat-support.e06a5320.png";